/**
 * Admin CMS queries — site_content (landing-page sections) fetch + edit +
 * publish.
 */
import { supabase } from '@/lib/supabase'

/** Fetch all site content sections.
 *
 *  Narrowed to the columns ContentContext + SectionEditor actually read.
 *  Both content_draft and content_published JSON blobs are needed because
 *  the `useContent({ draft })` hook picks between them per call site, and
 *  the admin SectionEditor compares draft against published. Dropping
 *  either would break the CMS. `label`, `published_at` are intentionally
 *  not selected — they're not read by any consumer today. */
export async function fetchAllSiteContent() {
  const { data, error } = await supabase
    .from('site_content')
    .select(
      'id, section_key, content_draft, content_published, is_visible, is_published, updated_at'
    )
  if (error) throw error
  return data || []
}

/** Toggle a section's visibility. */
export async function toggleSectionVisibility(sectionKey, isVisible) {
  const { error } = await supabase
    .from('site_content')
    .update({ is_visible: isVisible, updated_at: new Date().toISOString() })
    .eq('section_key', sectionKey)
  if (error) throw error
}

/** Publish a section — saves both draft and published content. */
export async function publishSection(sectionKey, content) {
  const { error } = await supabase
    .from('site_content')
    .update({
      content_draft: content,
      content_published: content,
      is_published: true,
      published_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    })
    .eq('section_key', sectionKey)
  if (error) throw error
}

/** Save draft content for a section (marks as unpublished). */
export async function saveSectionDraft(sectionKey, draftContent) {
  const { error } = await supabase
    .from('site_content')
    .update({
      content_draft: draftContent,
      is_published: false,
      updated_at: new Date().toISOString(),
    })
    .eq('section_key', sectionKey)
  if (error) throw error
}
